export default __webpack_public_path__ + "static/media/CV_Marina_Pavlovic.5cdff2b2.pdf";